import React, { useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { get } from 'lodash'
import ReactHtmlParser from 'react-html-parser'
import Typography from 'components/atoms/Typography/Typography'

import './VideoNetshow.scss'

const NETSHOW_EMBED_SCRIPT = 'https://static-videos.netshow.me/integration/embed.js'

function extractNetshowVideoCode(input) {
  if (!input) return ''
  const value = String(input).trim()
  if (!value) return ''
  const match = value.match(/netshow\.me\/(?:v|s)\/([A-Za-z0-9_-]+)/)
  if (match) return match[1]
  if (/^[A-Za-z0-9_-]+$/.test(value)) return value
  return ''
}

function VideoNetshow({ data }) {
  const title = get(data, 'title')
  const description = get(data, 'description.value')
  const rawUrls = get(data, 'netshow_urls') || get(data, 'netshow_url') || get(data, 'url')
  const urls = Array.isArray(rawUrls) ? rawUrls : [rawUrls]

  const embedUrls = urls
    .map((url) => extractNetshowVideoCode(url))
    .filter(Boolean)
    .map((videoCode) => `https://embed-videos.netshow.me/s/${videoCode}/player?v=true`)

  useEffect(() => {
    if (!embedUrls.length || typeof document === 'undefined') return
    if (document.querySelector(`script[src="${NETSHOW_EMBED_SCRIPT}"]`)) return
    const script = document.createElement('script')
    script.src = NETSHOW_EMBED_SCRIPT
    script.async = true
    document.body.appendChild(script)
  }, [embedUrls.length])

  if (!embedUrls.length) return null

  return (
    <Container className="video-netshow" fluid>
      <Container>
        {title && <Typography cssClass="video-netshow__title mb-3">{title}</Typography>}
        {description && <div className="video-netshow__description mb-3">{ReactHtmlParser(description)}</div>}
        {embedUrls.map((embedUrl, index) => (
          <div className="video-netshow__ratio" key={embedUrl + index}>
            <iframe
              src={embedUrl}
              title={title || 'Vídeo Netshow'}
              frameBorder="0"
              scrolling="no"
              allowFullScreen
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            />
          </div>
        ))}
      </Container>
    </Container>
  )
}

export default VideoNetshow
